import React, { memo, useState, useCallback } from 'react';
import { createUseStyles, Switch } from '@Sage/hoi-poi-ui';
import {
    applyLineSmartFieldOverridesToInputParams,
    getLineSmartFieldOverrides,
} from './applyLineSmartFieldOverrides';
import styles from './styles';

const useStyles = createUseStyles(styles, 'SwitchCell');

const SwitchCell = memo((params) => {
    const [isChecked, setIsChecked] = useState(params.value || false);
    const classes = useStyles();

    const field = params.colDef.field;
    const lineOverrides = getLineSmartFieldOverrides(params.data, field);
    const { onChange, ...inputParams } = applyLineSmartFieldOverridesToInputParams(
        params.inputParams,
        lineOverrides,
    );
    const handleOnChange = useCallback(() => {
        const id = params.data.id || params.data.Id || params.data.ID || '';
        onChange({ rowIndex: params.node.rowIndex, id, field, value: !isChecked });
        setIsChecked(!isChecked);
    }, [isChecked, onChange, field, params]);

    if (!params.inputParams) return null;

    return (
        <div className={['w5-cell', classes.editableCell].join(' ')}>
            <div className={classes.switchCell}>
                <Switch checked={isChecked} onChange={handleOnChange} {...inputParams} />
            </div>
        </div>
    );
});

export default SwitchCell;
